<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <!-- <topPiece></topPiece> -->
      <div class="event_main container">
        <!--        <template v-if="!detail_show">-->
        <!--          <titleConfig :title="langSet == 'cn' ?'现场活动':'Onsite Activities'" :type="2"></titleConfig>-->
        <!--          <div class="search_wrap">-->
        <!--            <search-->
        <!--                :type="'liveEvents'"-->
        <!--                :options="search_options"-->
        <!--                :placeholder_select="langSet == 'cn' ?'活动类型':'Activity Type'"-->
        <!--                :placeholder_input="langSet == 'cn' ?'请搜索活动名称':'Please search for the event name'"-->
        <!--                :select_key="'id'"-->
        <!--                :select_label="langSet == 'cn' ?'category_name':'en_category_name'"-->
        <!--                @query_change="query_change"-->
        <!--            ></search>-->
        <!--          </div>-->
        <!--          <div class="event_wrap flex flex_wrap" v-if="list.length > 0">-->
        <!--            <div class="event_list" v-for="(item, index) in list" :key="index" @click="item_click(item)">-->
        <!--              <div class="event_img">-->
        <!--                <el-image class="img" :src="item.image"></el-image>-->
        <!--              </div>-->
        <!--              <div class="event_title">-->
        <!--                {{ langSet == "cn" ? item.title : item.en_title }}-->
        <!--              </div>-->
        <!--              <div class="event_text">-->
        <!--                {{ langSet == "cn" ? '时间：' : 'Time：' }} {{ item.start_time }}-->
        <!--              </div>-->
        <!--              <div class="event_text">-->
        <!--                {{ langSet == "cn" ? '地点：' + item.place : 'Location：' + item.en_place }}-->
        <!--              </div>-->
        <!--              <div class="go_detail">{{ langSet == "cn" ? '查看详情' : 'View details' }}<img src="../../assets/go.png"/>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="page_wrap flex flex_content_center" v-if="list.length > 0">-->
        <!--            <el-pagination-->
        <!--                background-->
        <!--                :page-size="pageSize"-->
        <!--                :page-sizes="[5, 10, 15, 20, 30, 40, 50, 100]"-->
        <!--                layout="prev, pager, next, sizes"-->
        <!--                :total="totals"-->
        <!--                @current-change="currentChange"-->
        <!--                @size-change="sizeChange"-->
        <!--            >-->
        <!--            </el-pagination>-->
        <!--          </div>-->
        <!--          <nodata v-if="list.length == 0"></nodata>-->
        <!--        </template>-->
        <template>
          <div class="activity_big_box">
            <titleConfig
              v-if="false"
              :title="langSet == 'cn' ? '现场活动' : 'Onsite Activities'"
              :type="2"
            ></titleConfig>
            <newTitle
              style="margin-bottom: 30px"
              :title="langSet === 'cn' ? '现场活动' : 'Onsite Activities'"
            ></newTitle>
            <div class="activity_detail_top">
              <div class="detail_top_img">
                <el-image
                  :src="activity_detail.image"
                  v-if="activity_detail.image"
                ></el-image>
              </div>
              <div class="activity_sign_up">
                <div class="margin_bottom_12">
                  {{
                    langSet == "cn"
                      ? activity_detail.title
                      : activity_detail.en_title
                  }}
                </div>
                <div class="margin_bottom_12">
                  {{ langSet == "cn" ? "时间：" : "Time：" }}
                  {{ activity_detail.start_time }}
                </div>
                <div class="margin_bottom_12">
                  {{
                    langSet == "cn"
                      ? "地点：" + activity_detail.place
                      : "Location：" + activity_detail.en_place
                  }}
                </div>
                <div
                  v-if="
                    langSet == 'cn'
                      ? activity_detail.url != ''
                      : activity_detail.en_url != ''
                  "
                  @click="sign_up"
                >
                  {{ langSet == "cn" ? "立即报名" : "Register Now" }}
                </div>
              </div>
            </div>
            <div class="activity_detail_content">
              <Content_top
                :title="langSet == 'cn' ? '活动简介' : 'Activity Introduction'"
              ></Content_top>
              <div
                class="content_content"
                v-html="
                  langSet == 'cn'
                    ? activity_detail.content
                    : activity_detail.en_content
                "
              ></div>
            </div>
            <!--            <div class="go_back" @click="go_back">返回列表</div>-->
          </div>
        </template>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import newTitle from "@/components/new_title.vue";
import titleConfig from "@/components/title.vue";
//import topPiece from "@/components/topPiece.vue";
// import search from "@/components/Select_input_search.vue";
// import nodata from "@/components/nodata.vue";
import { activityList, ActivityCate, pc_activity_detail } from "@/api/api";
import Content_top from "@/components/content_top.vue";

export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    Content_top,
    top,
    bottom,
    newTitle,
    titleConfig,
    //topPiece,
    // search,
    // nodata
  },
  data() {
    return {
      detail_show: false,
      scrollTop: "",
      langSet: "",
      list: [],
      totals: 0,
      page_no: 1,
      pageSize: 10,
      cid: "",
      search_options: [],
      placeholder_select: "活动类型",
      placeholder_input: "请搜索活动名称",
      keywords: "",
      keywords_en: "",
      metaData: {},
      activity_detail: {},
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  async mounted() {
    let query = this.$route.query;
    if (query.detail_show) {
      this.loading = true;
      await this.get_activity_detail(query.id);
      this.loading = false;
    }
    this.langSet = this.$language;
    // //25.6.12 获取活动类型 dxm
    // this.activityCateList();
    // //25.6.12 获取列表 dxm
    // this.page_no = 1;
    // this.getList();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    query_change(data) {
      this.cid = data.select_value;
      this.page_no = data.pageNo;
      if (this.langSet == "cn") {
        this.keywords = data.search_input;
        this.keywords_en = "";
      } else {
        this.keywords = "";
        this.keywords_en = data.search_input;
      }
      this.getList();
    },
    async activityCateList() {
      const res = await ActivityCate();
      this.search_options = res.data.lists;
    },
    async getList() {
      let data = {
        page_no: this.page_no,
        page_size: this.pageSize,
        title: this.keywords,
        en_title: this.keywords_en,
        cid: this.cid,
      };
      const res = await activityList(data);
      this.list = res.data.lists;
      this.totals = res.data.count;
    },
    // item_click(item) {
    //   this.get_activity_detail(item.id)
    // },
    async get_activity_detail(id) {
      let data = {
        id: id,
      };
      const res = await pc_activity_detail(data);
      this.activity_detail = res.data;
      this.activity_detail.content =
        res.data.content.length > 0
          ? res.data.content.replace(/\<img/gi, '<img width="100%"')
          : res.data.content;
      this.activity_detail.en_content =
        res.data.en_content.length > 0
          ? res.data.en_content.replace(/\<img/gi, '<img width="100%"')
          : res.data.en_content;
      // this.change_detail_show()
    },
    change_detail_show() {
      this.scrollTop = window.scrollY;
      this.detail_show = !this.detail_show;
      window.scrollTo(0, 0);
    },
    go_back() {
      this.detail_show = !this.detail_show;
      setTimeout(() => {
        window.scrollTo(0, this.scrollTop);
      });
    },
    currentChange(e) {
      this.page_no = e;
      this.getList();
    },
    sizeChange(e) {
      this.page_no = 1;
      this.pageSize = e;
      this.getList();
    },
    sign_up() {
      let url =
        this.langSet == "cn"
          ? this.activity_detail.url
          : this.activity_detail.en_url;
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.event_main {
  padding-bottom: 100px;
  .search_wrap {
    margin-top: 40px;
  }
}

.event_wrap {
  margin: 30px 0;
  .event_list {
    cursor: pointer;
    width: calc((100% - 80px) / 3);
    height: 398px;
    padding: 15px;
    box-sizing: border-box;
    background: #f7f8fa;
    margin: 0 40px 40px 0;
    font-size: 18px;
    color: #757575;
    line-height: 25px;

    &:hover {
      border: 1px solid #004190;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }

    .event_img {
      width: 100%;
      height: 208px;
      overflow: hidden;

      .img {
        width: 100%;
        max-height: auto;
      }
    }

    .event_title {
      font-weight: 500;
      font-size: 20px;
      color: #2c2c2e;
      //height: 80px;
      height: 56px;
      line-height: 28px;
      //padding: 12px 0;
      margin: 12px 0;
      overflow: hidden;
      box-sizing: border-box;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .event_text {
      margin-bottom: 12px;
    }

    .go_detail {
      display: none;
    }
  }
}

//详情
.activity_big_box {
  .activity_detail_top {
    display: flex;
    align-items: center;
    padding: 30px;
    background: #f7f8fa;

    .detail_top_img {
      .el-image {
        width: 370px;
        height: 208px;
        background: #ffffff;
      }
    }

    .activity_sign_up {
      margin-left: 30px;
    }

    .activity_sign_up div:nth-child(1) {
      font-weight: 600;
      font-size: 20px;
      color: #2c2c2e;
      line-height: 28px;
      text-align: left;
      font-style: normal;
    }

    .activity_sign_up div:nth-child(2) {
      font-weight: 400;
      font-size: 18px;
      color: #757575;
      line-height: 25px;
      text-align: left;
      font-style: normal;
    }

    .activity_sign_up div:nth-child(3) {
      font-weight: 400;
      font-size: 18px;
      color: #757575;
      line-height: 25px;
      text-align: left;
      font-style: normal;
    }

    .activity_sign_up div:nth-child(4) {
      width: 200px;
      height: 48px;
      background: #e62344;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
    }
  }
  .go_back {
    width: 280px;
    height: 68px;
    background: #004190;
    line-height: 68px;
    text-align: center;
    border-radius: 12px;
    color: #fff;
    margin: 50px auto;
    cursor: pointer;
  }
}

.margin_bottom_12 {
  margin-bottom: 12px;
}

@media only screen and (max-width: 767px) {
  .event_wrap {
    display: block;

    .event_list {
      width: 100%;
      height: 6.9rem;

      .event_title {
        height: 0.81rem;
        font-size: 0.29rem;
        color: #2c2c2e;
        line-height: 0.4rem;
        text-align: left;
        font-style: normal;
        //padding: 0.19rem 0;/
      }

      .event_text {
        font-size: 0.25rem;
        color: #757575;
        line-height: 0.35rem;
        text-align: left;
        font-style: normal;
        margin-bottom: 0.19rem;
      }

      .go_detail {
        display: flex;
        justify-content: right;
        align-items: center;
        font-weight: 400;
        font-size: 0.29rem;
        color: #e62344;
        line-height: 0.54rem;
        text-align: right;
        font-style: normal;

        img {
          width: 0.31rem;
        }
      }
    }
  }

  .activity_big_box {
    .activity_detail_top {
      display: block;
      //width: 100%;
      //height: 6.5rem;
      padding: 0.29rem;
      margin-bottom: 0.38rem;
      margin-top: 0.38rem;

      .detail_top_img {
        .el-image {
          width: 100%;
          background: #ffffff;
        }
      }

      .activity_sign_up {
        margin: 0.29rem 0 0 0;
      }

      .activity_sign_up div:nth-child(1) {
        font-weight: 600;
        font-size: 0.29rem;
        color: #2c2c2e;
        line-height: 0.4rem;
        text-align: left;
        font-style: normal;
      }

      .activity_sign_up div:nth-child(2) {
        font-weight: 400;
        font-size: 0.25rem;
        color: #757575;
        line-height: 0.35rem;
        text-align: left;
        font-style: normal;
      }

      .activity_sign_up div:nth-child(3) {
        font-weight: 400;
        font-size: 0.25rem;
        color: #757575;
        line-height: 0.35rem;
        text-align: left;
        font-style: normal;
      }

      .activity_sign_up div:nth-child(4) {
        width: 3.04rem;
        height: 0.69rem;
        background: #e62344;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-weight: 400;
        font-size: 0.27rem;
        line-height: 0.38rem;
        text-align: center;
        font-style: normal;
      }
    }
  }
}
</style>